import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Default from "./layouts/Default";
import NoSliderLayout from "./layouts/NoSliderLayout";
import Footer from "./components/shared/Footer/Footer";
import "./App.css";
import RedirectLink from "./components/shared/Redirect/RedirectLink";
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Switch>
          <Route exact path="/" component={Default} />
          <Route exact path="/login" component={Default} />
          <Route exact path="/signup" component={Default} />
          <Route exact path="/products" component={Default} />
          <Route exact path="/solutions" component={Default} />
          <Route exact path="/support" component={Default} />
          <Route exact path="/developers" component={Default} />
          <Route exact path="/companies" component={Default} />
          <Route exact path="/pricing" component={Default} />
          <Route exact path="/about-us" component={Default} />
          <Route exact path="/leadership_team" component={Default} />
          <Route exact path="/gettingstarted" component={Default} />
          <Route exact path="/contact" component={Default} />
          <Route exact path="/chatbots" component={Default} />
          <Route exact path="/texttospeech" component={Default} />
          <Route exact path="/code-review" component={Default} />
          <Route exact path="/healthcare" component={Default} />
          <Route exact path="/imageanalysis" component={Default} />
          <Route exact path="/documentanalysis" component={Default} />
          <Route exact path="/noisecancelling" component={Default} />
          <Route exact path="/frauddetector" component={Default} />
          <Route exact path="/textanalytics" component={Default} />
          <Route exact path="/forecast" component={Default} />
          <Route exact path="/personalassistant" component={Default} />
          <Route
            exact
            path="/personalizedrecommendations"
            component={Default}
          />
          <Route exact path="/enterprisesearch" component={Default} />
          <Route exact path="/api" component={Default} />
          <Route exact path="/platformoverview" component={Default} />
          <Route exact path="/explore-our-tools" component={Default} />
          <Route exact path="/translateai" component={Default} />
          <Route exact path="/learn" component={Default} />
          <Route exact path="/documentation" component={Default} />
          <Route exact path="/whats_new" component={Default} />
          <Route exact path="/careers" component={Default} />
          <Route exact path="/blog" component={Default} />
          <Route exact path="/news" component={Default} />
          <Route exact path="/termsofservice" component={Default} />
          <Route exact path="/privacypolicy" component={Default} />
          <Route path="/card-details/:id" exact component={Default} />
          <Route component={RedirectLink} />
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
